module.exports = __webpack_public_path__ + "img/profesionalismo.49455fb0.png";